import { network } from 'services/network';

export const getContract = (contractId) => {
    return network.get(`api/bo/management/getContract?contractId=${contractId}`).then((response) => {
        return response.data;
    });
};
